import React, { Component } from "react"
import { SelectField, MenuItem, TextField } from "material-ui"
import { IFilterEntry, IUserFilter } from "../../../models"
import MultiSupervisorChips from "../../supervisor/MultiSupervisorChips"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import FilterTemplateOptionalBoolParametersChips from "../FilterTemplateOptionalBoolParametersChips"
import ChooseHierarchyJobSelector from "../../hierarchy_job/ChooseHierarchyJobSelector"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import ChipSelect from "../../common/ChipSelect"

interface IProps {
    editFilterTemplate: IUserFilter
}
interface IState {
    filterData: IUserFilter
}

export default class AddUsersFilterTemplateDialogContainer extends Component<IProps, IState> {
    private optionalBoolParameterNames: string[]
    constructor(props: IProps) {
        super(props)
        this.optionalBoolParameterNames = ["Exempt", "AllowPunchFromPersonalDevice", "SelfServiceLoginEnabled"]
        AccountStore.getCurrentAccountSettings().FeatureSettings.EnableFinddPolicy &&
            this.optionalBoolParameterNames.push("MobileAgreementAccepted")
        AccountStore.getCurrentAccount().AccountSettings.RequireAgreement &&
            this.optionalBoolParameterNames.push("AccountAgreementAccepted")
        this.optionalBoolParameterNames.push("UserModified", "Agency")
        AccountStore.getPhasesEnabled() &&
            this.optionalBoolParameterNames.push("RequirePhase")

        this.state = {
            filterData: props.editFilterTemplate ?
                props.editFilterTemplate :
                {
                    Id: "",
                    Name: "",
                    ActiveUsers: true,
                    Exempt: null,
                    SelfServiceLoginEnabled: null,
                    AllowPunchFromPersonalDevice: null,
                    MobileAgreementAccepted: null,
                    UserModified: null,
                    HierarchyJobs: [],
                    Supervisors: [],
                    RequirePhase: null,
                    PayGroupIds: [],
                    CustomField1: "",
                    CustomField2: "",
                    CustomField3: "",
                    CustomField4: "",
                } as IUserFilter
        }
    }

    render() {
        const { filterData } = this.state
        return (
            <div>
                <div>
                    <SelectField
                        floatingLabelText={strings.Active_Status}
                        value={this.state.filterData.ActiveUsers}
                        onChange={(event, key, value) => {
                            this.setState({ filterData: { ...filterData, ActiveUsers: value } })
                        }}
                        style={{ width: 250 }}
                    >
                        <MenuItem value={true} primaryText={strings.Active} />
                        <MenuItem value={false} primaryText={strings.Inactive} />
                    </SelectField>
                </div>
                <div style={{ marginTop: 10 }}>
                    <FilterTemplateOptionalBoolParametersChips
                        parameterNames={this.optionalBoolParameterNames}
                        useYesNoLabelparameterNames={["MobileAgreementAccepted", "AccountAgreementAccepted"]}
                        optionalParameterValues={this.optionalBoolParameterNames.filter(i => filterData[i] === true || filterData[i] === false).map(i => { return { Name: i, Value: filterData[i] } })}
                        handleChange={optionalParameterValues => {
                            this.optionalBoolParameterNames.forEach(i => {
                                const parameterValue = optionalParameterValues.find(e => e.Name === i)
                                filterData[i] = parameterValue ? parameterValue.Value : null
                            })
                            this.setState({ filterData })
                        }}
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <ChooseHierarchyJobSelector
                        hierarchyJobs={filterData.HierarchyJobs || []}
                        handleChange={hierarchyJobs => this.setState({ filterData: { ...filterData, HierarchyJobs: hierarchyJobs } })}
                    />
                </div>
                {AccountStore.getSupervisorDirectReportEnabled() &&
                    <div style={{ marginTop: 10 }}>
                        <MultiSupervisorChips
                            selectedSupervisorIds={filterData.Supervisors ? filterData.Supervisors.map(i => i.Id) : []}
                            canChooseYourSelf
                            readonly={false}
                            handleChange={supervisors => this.setState({ filterData: { ...filterData, Supervisors: supervisors.map(i => { return { Id: i.Id, Name: `${i.FirstName} ${i.LastName}` } as IFilterEntry }) } })}
                            supervisorRestrictHierarchyId={AuthenticationStore.getLoggedInUser().OrganizationHierarchyId}
                        />
                    </div>
                }
                <div style={{ marginTop: 10 }}>
                    <ChipSelect
                        title={strings.Pay_Groups}
                        titleStyle={{ fontSize: 16 }}
                        allData={AccountStore.getCurrentAccount().PayGroups.filter(i => !i.Deleted)}
                        linkedData={AccountStore.getCurrentAccount().PayGroups.filter(i => this.state.filterData.PayGroupIds ? this.state.filterData.PayGroupIds.includes(i.Id) : false)}
                        chipStyle={{ marginTop: 10, marginRight: 5, height: 35 }}
                        addButtonStyle={{ height: 33, marginTop: 2, display: "inline-block", marginLeft: -5 }}
                        labelTextForSelect={strings.Select_Pay_Group}
                        handleAddOne={item => {
                            const payGroupIds = this.state.filterData.PayGroupIds
                            payGroupIds.push(item.Id)
                            this.setState({ filterData: { ...filterData, PayGroupIds: payGroupIds } })
                        }}
                        handleDeleteOne={item => {
                            const payGroupIds = this.state.filterData.PayGroupIds
                            const indexOf = payGroupIds.indexOf(item.Id)
                            if (indexOf > -1)
                                payGroupIds.splice(indexOf, 1)
                            this.setState({ filterData: { ...filterData, PayGroupIds: payGroupIds } })
                        }}
                        errorText=""
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <TextField
                        floatingLabelText="Custom Field 1"
                        value={filterData.CustomField1 || ""}
                        onChange={(e, value) => this.setState({ 
                            filterData: { ...filterData, CustomField1: value } 
                        })}
                        style={{ width: 250 }}
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <TextField
                        floatingLabelText="Custom Field 2"
                        value={filterData.CustomField2 || ""}
                        onChange={(e, value) => this.setState({ 
                            filterData: { ...filterData, CustomField2: value } 
                        })}
                        style={{ width: 250 }}
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <TextField
                        floatingLabelText="Custom Field 3"
                        value={filterData.CustomField3 || ""}
                        onChange={(e, value) => this.setState({ 
                            filterData: { ...filterData, CustomField3: value } 
                        })}
                        style={{ width: 250 }}
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <TextField
                        floatingLabelText="Custom Field 4"
                        value={filterData.CustomField4 || ""}
                        onChange={(e, value) => this.setState({ 
                            filterData: { ...filterData, CustomField4: value } 
                        })}
                        style={{ width: 250 }}
                    />
                </div>
            </div>
        )
    }
}
